__webpack_require__.p = "/yugioh-converter/";